<template>
  <div v-if="fileLists">
    <el-table
      height="450"
      :data="fileLists || []"
      class="upload_table"
      ref="table"
      style="width:100%"
    >
      <template slot="empty">
        <div class="emptyTemplate">
          <div>
            <img src="@/assets/img/printingPage/empty.png" alt="" />
            <span>暂无文件</span>
          </div>
        </div>
      </template>
      <el-table-column
        class="name"
        prop="name"
        label="序号"
        width="100"
        type="index"
      >
      </el-table-column>
      <el-table-column class="name" prop="name" label="打印机" min-width="25%">
        <template>
          <el-popover
            placement="right"
            trigger="hover"
            :content="order.printer.equipmentAlias"
          >
            <p slot="reference" class="fileNameOver">
              {{ order.printer.equipmentAlias }}
            </p>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        class="name"
        prop="fileName"
        label="文件名"
        min-width="25%"
      >
        <template slot-scope="scope">
          <el-popover
            placement="right"
            trigger="hover"
            :content="scope.row.fileName"
          >
            <p slot="reference" class="fileNameOver">
              {{ scope.row.fileName }}
            </p>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column class="name" label="打印参数" min-width="20%">
        <template slot-scope="scope">
          <p slot="reference" class="fileNameOver">
            {{ scope.row.paperSize }}
            |
            {{ scope.row.colorMode === "0" ? "黑白" : "彩色" }}
            |
            {{ scope.row.singleDoubleSides === "single" ? "单面" : "双面" }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        class="name"
        prop="printPages"
        label="页数"
        min-width="10%"
      >
      </el-table-column>
      <el-table-column
        class="name"
        prop="printingCopies"
        label="份数"
        min-width="10%"
      >
      </el-table-column>
    </el-table>
    <div class="btnBox" v-if="orderPrice">
      <div class="left">
        <span>合计：</span>
        <span>{{ orderPrice || "0.00" }}元</span>
      </div>
      <div @click="togglePayBillModal" class="printBtn">
        支付并打印
      </div>
    </div>
    <PayBill
      :show.sync="payBillModal"
      :destoryDlg="destoryDlg"
      @toggleConfirmModal="toggleConfirmModal"
    />
    <ConfirmOrder
      :show.sync="confirmModal"
      :orderId="order.id"
      :order="order"
      @togglePayBillModal="togglePayBillModal"
      @updatePrintingList="updatePrintingList"
      @showError="showError"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { calculatePrice } from "api/api";
import PayBill from "./PayBill.vue";
import ConfirmOrder from "./ConfirmOrder.vue";

export default {
  data: function() {
    return {
      fileLists: null,
      payBillModal: false,
      confirmModal: false,
      orderPrice: null,
      destoryDlg: () => {},
    };
  },
  computed: {
    ...mapState("batch", ["order", "uploadLists"])
  },
  components: {
    PayBill,
    ConfirmOrder
  },
  methods: {
    init() {
      const { printer, settingParams } = this.order;
      calculatePrice({
        id: printer.id,
        printNoList: settingParams.map(item => item.printNo)
      }).then(({ data }) => {
        this.orderPrice = data.payPrice;
        this.fileLists = data.itemList;
      });
    },
    showError() {
      const { destory } = this.$alert({
        description: "订单尚未完成支付"
      });
      this.destoryDlg = destory;
    },
    togglePayBillModal() {
      this.payBillModal = !this.payBillModal;
    },
    toggleConfirmModal(bool) {
      this.confirmModal = bool;
    },
    updatePrintingList() {
      this.$emit("updatePrintingList", true);
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped lang="scss">
.emptyTemplate {
  display: flex;
  align-items: center;
  justify-content: center;
  div {
    display: flex;
    flex-direction: column;
    color: #424242;
    font-size: 16px;
    span {
      margin: 18px 0 0 0;
    }
  }
}

.btnBox {
  display: flex;
  margin: 20px 0;
  justify-content: space-between;
  align-items: center;
  .left {
    display: flex;
    align-items: flex-end;
    span:nth-child(1) {
      font-size: 14px;
    }
    span:nth-child(2) {
      font-size: 22px;
      color: #ff5533;
    }
  }
  .printBtn {
    width: 115px;
    height: 48px;
    text-align: center;
    color: white;
    line-height: 48px;
    background-color: $theme-color;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    margin-right: 20px;
    &:hover {
      background-color: $theme-color-hover;
    }
  }
}
</style>

<style lang="scss">
.upload_table {
  tbody {
    .cell {
      padding-left: 10px !important;
    }
  }
}
</style>
